export default __webpack_public_path__ + "static/til-e69a1088abf07660a628b6524432ebc1.png";